import React, { useEffect } from 'react';
import AlertIcon from '../../_styles/images/AlertIcon.png';
import CloseIcon from '../../_styles/images/delete.png';
import DriverIcon1 from '../../_styles/images/new-icons/CompleteRide.png';
import DriverIcon from '../../_styles/images/CompleteRide_black.svg';
import analyticsService from '../../shared/analytics/analytics-service';
import RightArrow from '../../_styles/images/new-icons/RightArrow.png';
import blackAlertIcon from '../../_styles/images/new-icons/black-warning.png'

export default function Banner(props) {
    const { banner, isDismissible, close } = props;
    const driverBanner = banner.alertTypeCode.toLowerCase().includes("db") && banner.priority == 2;

    function dismissBanner() {
        analyticsService.analyticsProcessEvent({
            "event": "banner interaction",
            "context": {
                "event_action": "dismiss",
                "banner_topic": `${banner.summary}`
            }
        });
        close(banner);
    }
    
    function createMarkup(description){
        return {__html: description};
    }

    const navigateToProfile = () => {
        props.history.push('myprofile');
    }

    return (
        <div className={`notification-banner ${isDismissible ? 'is-dismissible' : ''} ${driverBanner ? 'driver-banner' : ''}`} role='group' key={banner.alertId} onClick={driverBanner ? navigateToProfile : undefined}>
            <div className='main-content'>
                <div className='notification-icon'>
                    <img className='notification-alert-icon' alt='alert icon' src={`${ driverBanner ? DriverIcon : isDismissible ? blackAlertIcon : AlertIcon }`} aria-hidden='true' />
                </div>
                <div className='notification-content'>
                    <div className='notification-header'>
                        {banner.summary?.toLowerCase().replace(/(?<!['`])\b[a-z]/g, char => char.toUpperCase())}
                    </div>
                    <div className='notification-description' dangerouslySetInnerHTML={createMarkup(banner.description)}>
                        {/* {banner.description} */}
                    </div>

                </div>
            </div>
            {
                isDismissible  && !driverBanner?
                    <div className='notification-dismiss'>
                        <img alt='close icon' src={CloseIcon} onClick={(e) => { e.stopPropagation(); dismissBanner(); }} role='button' />
                    </div>
                    :
                    null
            }
            {
                driverBanner &&
                <div className='notification-icon-arrow'>
                    <img className='notification-alert-icon-arrow' alt='alert icon' src={RightArrow} aria-hidden='true' />
                </div>
            }
        </div>
    );
}